import logo from '../images/jumia_images/jumia_logo.png';
import iphone from '../images/jumia_images/iphone 12.jpg';
import homeImage from '../images/jumia_images/Holiday-Savings-Slider-4.jpg';
import helpCenter from '../images/jumia_images/help_center.png';
import easyReturn from '../images/jumia_images/returns-refunds.png';
import sell from '../images/jumia_images/sell-on-jumia.png';
import stores from '../images/jumia_images/JumiaMal.png';
import global from '../images/jumia_images/JumiaGlobal.png';
import prime from '../images/jumia_images/JumiaPrime.png';
import food from '../images/jumia_images/JumiaFood.png';



export const images = {
    logo: logo,
    iphone: iphone,
    homeImage: homeImage,
    helpCenter: helpCenter,
    easyReturn: easyReturn,
    sell: sell,
    stores: stores,
    global: global,
    prime: prime,
    food: food,
}